import { Delete, Edit } from "@mui/icons-material";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from 'material-react-table';
import React from "react";
import ArrayToCSV from "../../../components/ArrayToCSV/ArrayToCSV";

function MaterialTable(props) {
  return (
    <MaterialReactTable
    enableStickyHeader
    muiTableContainerProps={{ sx: { maxHeight: "500px" } }}
    displayColumnDefOptions={{
      "mrt-row-actions": {
        muiTableHeadCellProps: {
          align: "center",
        },
        size: 120,
      },
    }}
      columns={props.columns}
      data={props.tableData}
      editingMode="modal" //default
      enableColumnOrdering
      enableEditing
      onEditingRowSave={props.handleSaveRowEdits}
      onEditingRowCancel={props.handleCancelRowEdits}
      renderRowActions={({ row, table }) => (
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
          }}
        >
          <Tooltip arrow placement="left" title="Edit">
            <IconButton onClick={() => table.setEditingRow(row)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip arrow placement="right" title="Delete">
            <IconButton
              color="error"
              onClick={() => props.handleDeleteRow(row)}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      renderTopToolbarCustomActions={() => (
        <>
          <ArrayToCSV data={props.tableData} csvFileName={props.csvFileName} />
          <Button
            onClick={() => props.setCreateModalOpen(true)}
            variant="contained"
          >
            Create New
          </Button>
         {props.children}
          
        </>
      )}
    />
  );
}

export default MaterialTable;
